module.exports = __webpack_public_path__ + "static/media/hermes.40e1e1ea.png";